import _ from 'lodash';

const search = (term) => {
  const service = new window.google.maps.places.AutocompleteService();
  return new Promise((resolve) => {
    service.getPlacePredictions({
      input: term,
      componentRestrictions: { country: ['us', 'au'] },
    },
    (results) => {
      resolve(results);
    });
  },
  );
};

const getDistance = (origin, destination) => {
  const distanceService = new window.google.maps.DistanceMatrixService();

  return new Promise((resolve, reject) => {
    distanceService.getDistanceMatrix({
      origins: [{ placeId: origin }],
      destinations: [{ placeId: destination }],
      travelMode: window.google.maps.TravelMode.DRIVING,
      unitSystem: window.google.maps.UnitSystem.IMPERIAL,
      durationInTraffic: false,
      avoidHighways: false,
      avoidTolls: false,
    },
    (results, status) => {
      if (status === window.google.maps.DistanceMatrixStatus.OK) {
        // .000621371192 is converting meters to miles
        resolve(Math.round(_.get(results, 'rows[0].elements[0].distance.value', 0) * 0.000621371192));
      } else {
        reject();
      }
    });
  });
};

const getUserPosition = () => new Promise((resolve, reject) => {
  navigator.geolocation.getCurrentPosition((position) => {
    resolve(position.coords);
  }, () => {
    reject();
  });
},
);

const searchCode = (term) => {
  const service = new window.google.maps.Geocoder();
  return new Promise((resolve) => {
    service.geocode(term, (results) => {
      resolve(results);
    });
  },
  );
};


export default {
  search,
  getUserPosition,
  searchCode,
  getDistance,
};



// WEBPACK FOOTER //
// ./src/api/map.js